import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { ranuButtonSx } from "layouts/receipt/components/SectionCard";

import { Login } from "APIs/UserAuthenticationAPIs";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

const SIGN_IN_BG =
  "https://sandbox-cdn.tuljamaa.org/tuljamaa/website-images/admin-panelSarovar.JPG";

function Basic({ ChangeLoggedIn }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isIncorrect, setIsIncorrect] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await Login({ phone, password, dispatch });
      if (response !== null) {
        ChangeLoggedIn(true);
        setIsIncorrect(false);
        navigate("/");
      } else {
        setIsIncorrect(true);
      }
    } catch (err) {
      console.error(err);
      setIsIncorrect(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BasicLayout image={SIGN_IN_BG} overlay={false}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="primary"
          borderRadius="lg"
          coloredShadow="primary"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleOnSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="tel"
                label="Phone"
                fullWidth
                required
                value={phone}
                onChange={(e) => {
                  setIsIncorrect(false);
                  setPhone(e.target.value);
                }}
              />
            </MDBox>
            <MDBox mb={1}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                required
                value={password}
                onChange={(e) => {
                  setIsIncorrect(false);
                  setPassword(e.target.value);
                }}
              />
            </MDBox>
            {isIncorrect && (
              <MDBox display="flex" justifyContent="center">
                <MDTypography variant="button" color="error">
                  Incorrect Credentials!
                </MDTypography>
              </MDBox>
            )}
            <MDBox mt={2} mb={1}>
              <MDButton
                color="primary"
                fullWidth
                type="submit"
                disabled={loading}
                sx={ranuButtonSx}
              >
                {loading ? "signing in..." : "sign in"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

Basic.propTypes = {
  ChangeLoggedIn: PropTypes.func,
};

export default Basic;
